import { render, staticRenderFns } from "./userWalletLog.vue?vue&type=template&id=47ce522e&scoped=true&"
import script from "./userWalletLog.vue?vue&type=script&lang=js&"
export * from "./userWalletLog.vue?vue&type=script&lang=js&"
import style0 from "./userWalletLog.vue?vue&type=style&index=0&id=47ce522e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce522e",
  null
  
)

export default component.exports